<template>
	<UiElement tag="button" :settings="settings" @changeActive="changeActive">
		<slot />

		<div
			class="awrp"
			:style="arrowStyle"
			:class="{
					'right': right,
					'left': !right,
				}"
		>
			<i
				class="arrow"
				:class="{
					'arrow--right': right,
					'arrow--left': !right,
				}"
			/>
		</div>
	</UiElement>
</template>

<script setup>
	import { defineProps, ref, computed } from 'vue';
	import UiElement from '@/components/UI/UiElement.vue';
	import { useElementStyles } from '@/composables/useElementStyles';

	const { getColorOrVariable } = useElementStyles();

	const props = defineProps({
		settings: {
			type: Object,
			required: true,
		},
		body: {
			type: Object,
			required: true,
		},
		right: {
			type: Boolean,
			default: false,
		}
	});

	const isActive = ref(false);

	const arrowStyle = computed(() => {
		const { borderWidth, color } = props.settings.border;
		const height = Number(props.settings.size.height);
		const { background } = props.settings;
		const pageBackground = props.body.background;
		const arrowSideWidth = height / Math.sqrt(2)

		return {
			'--awrp-height': `${height + 2}px`,
			'--arrow-wrapper-background': getColorOrVariable(pageBackground[0]),
			'--arrow-wrapper-width': `${height / 2}px`,
			'--arrow-wrapper-height': `${height}px`,
			'--arrow-wrapper-padding': `${height / 2 + (borderWidth / 2)}px`,
			'--arrow-wrapper-offset': `-${borderWidth}px`,
			'--arrow-shape-width-size': `${arrowSideWidth + (borderWidth / 3)}px`,
			'--arrow-shape-offset': `-${arrowSideWidth / 2}px`,
			'--arrow-shape-border-color': getColorOrVariable(color),
			'--arrow-shape-border-width': `${borderWidth}px`,
			'--arrow-shape-background': getColorOrVariable(background[0]),
		}
	});

	function changeActive(value) {
		isActive.value = value;
	}
</script>

<style lang="scss" scoped>
	.awrp {
		position: absolute;
		top: var(--arrow-wrapper-offset);
		width: var(--arrow-wrapper-width);
		height: var(--awrp-height);
		display: flex;
		justify-content: center;
		align-items: center;
		background: var(--arrow-wrapper-background);

		&.left {
			left: var(--arrow-wrapper-offset);
		}

		&.right {
			right: var(--arrow-wrapper-offset);
		}
	}

	.arrow {
		position: absolute;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		width: var(--arrow-wrapper-width);
		height: var(--arrow-wrapper-height);
		overflow: hidden;

		&:before {
			content: '';
			position: absolute;
			width: var(--arrow-shape-width-size);
			height: var(--arrow-shape-width-size);
			border: var(--arrow-shape-border-width) solid var(--arrow-shape-border-color);
			background: var(--arrow-shape-background);
			overflow: hidden;
		}

		&--left {
			left: 0;
			padding-left: var(--arrow-wrapper-padding);

			&:before {
				right: var(--arrow-shape-offset);
				transform: rotate(-45deg);
				border-bottom: 0;
				border-right: 0;
			}
		}

		&--right {
			right: 0;
			padding-right: var(--arrow-wrapper-padding);

			&:before {
				left: var(--arrow-shape-offset);
				transform: rotate(45deg);
				border-bottom: 0;
				border-left: 0;
			}
		}
	}
</style>

